import * as React from 'react';
import * as reportDispatch from 'redux/ducks/reportData';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import FoodWasteDistribution from './FoodWasteDistribution';
import { ReportActions } from 'redux/ducks/reportFilter';
import { CHART_COLORS } from 'pages/Report';
import createValueFormatter from 'pages/Report/utils/createValueFormatter';
import getChartData from 'pages/Report/components/Chart/utils/getChartData';
import { seriesMappers, themeMapper } from './utils/chartMappers';
import { useIntl } from 'react-intl';
import { RootState } from 'redux/rootReducer';
import { ThunkDispatch } from 'redux-thunk';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

interface ComponentProps extends StateProps, DispatchProps {}

const identifier = 'foodWasteOverview';

const FoodWasteDistributionContainer: React.FunctionComponent<ComponentProps> = (props) => {
  const intl = useIntl();
  const { foodwasteOverview, fetchData, filter } = props;
  const {
    data: { series },
    dimension,
    basis,
    error
  } = foodwasteOverview;
  const valueFormatter = createValueFormatter(dimension, basis);
  const columnChartOptions = getChartData(
    {
      series: series[1] ? [series[1]] : [],
      unit: (series[1] || {}).unit,
      chartColors: CHART_COLORS,
      intl
    },
    seriesMappers(valueFormatter),
    themeMapper(valueFormatter)
  );

  useEffect(() => {
    void fetchData(identifier);
  }, [
    filter.basis,
    filter.dimension,
    filter.timeRange,
    filter.period,
    filter.filter,
    filter.selectedGuestTypeNames
  ]);

  return (
    <FoodWasteDistribution
      chartsData={foodwasteOverview}
      columnChartOptions={columnChartOptions}
      chartColors={CHART_COLORS}
      error={error}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  foodwasteOverview: state.reportData[identifier],
  filter: state.reportFilter
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, ReportActions>) => ({
  fetchData: (identifier: keyof reportDispatch.ReportDataState) =>
    dispatch(reportDispatch.fetchData(identifier))
});

export default connect<StateProps, DispatchProps, unknown>(
  mapStateToProps,
  mapDispatchToProps
)(FoodWasteDistributionContainer);
